export const isAttachmentDeleteDisabled = ({
  fieldDisabled,
  canDelete,
}: {
  fieldDisabled: boolean;
  canDelete: boolean;
}) => fieldDisabled || !canDelete;
